import { render } from "./editUser.vue?vue&type=template&id=9896eaca"
import script from "./editUser.vue?vue&type=script&lang=js"
export * from "./editUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__